import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=f4f68d66&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=f4f68d66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f68d66",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f4f68d66')) {
      api.createRecord('f4f68d66', component.options)
    } else {
      api.reload('f4f68d66', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=f4f68d66&scoped=true&", function () {
      api.rerender('f4f68d66', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Eb5TuAN7RVhS/JS/comp/SearchFilterTokens.vue"
export default component.exports